import styled from 'styled-components';

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-transform: uppercase;
  min-width: 64px;
  width: fit-content;
  padding: 5px 15px;
  min-height: 32px;
  cursor: pointer;
  user-select: none;
  vertical-align: middle;
  text-decoration: none;
  border-radius: 3px;
  border: none;
  font-weight: 500;
  background-color: rgba(0, 0, 0, 0.05);
  outline: 1px solid #ccc;
  color: 1px solid black;
  margin: 8px 0;
  &:disabled {
    color: rgba(0, 0, 0, 0.26);
    outline: 1px solid rgba(0, 0, 0, 0.12);
    opacity: 0.7;
    cursor: default;
  }
`;

export default Button;
